import produce from 'immer';
import { ProductionPlanningEventWeek } from '~/domain/model';
import { createCreator, createReducer, Reducer } from '~/helpers/util/reducers';

export type Status = 'cleared' | 'updated';

export type ProductionPlanningEventWeekState = {
  productionPlanningEventWeekById: Map<string, ProductionPlanningEventWeek>;
  status: Status;
};

export type Update = {
  productionPlanningEventWeekById: Map<string, ProductionPlanningEventWeek>;
};

const prefix = '@productionPlanningEventWeek';

export const Types = Object.freeze({
  CLEAR: `${prefix}/CLEAR`,
  UPDATE: `${prefix}/UPDATE`
});

export const initialState: ProductionPlanningEventWeekState = {
  productionPlanningEventWeekById: new Map(),
  status: 'cleared'
};

const clearReducer: Reducer<ProductionPlanningEventWeekState, void> = state => {
  return produce(state, draft => {
    draft.productionPlanningEventWeekById =
      initialState.productionPlanningEventWeekById;
    draft.status = initialState.status;
  });
};

const updateReducer: Reducer<ProductionPlanningEventWeekState, Update> = (
  state,
  action
) => {
  return produce(state, draft => {
    draft.productionPlanningEventWeekById =
      action.productionPlanningEventWeekById as Map<
        string,
        ProductionPlanningEventWeek
      >;
  });
};

export const actions = Object.freeze({
  clear: createCreator<void>(Types.CLEAR),
  update: createCreator<Update>(Types.UPDATE)
});

export const reducer = createReducer(initialState, {
  [Types.CLEAR]: clearReducer,
  [Types.UPDATE]: updateReducer
});
